import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const CustomMenuInternal = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const CustomMenu = _ref2 => {
  let {
    innerRef,
    innerProps,
    children
  } = _ref2;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: innerRef
  }, innerProps), {}, {
    children: children
  }));
};